module.exports = __webpack_public_path__ + "static/media/selo.b646ac0e.png";